import React from 'react';
import Footer from './components/Footer';
import {useLocation, useSearchParams, useNavigate } from 'react-router-dom'

const CONTENT = {
  successText: {
    en:'Booking Success!',
    tc:'訂房成功！',
    sc:'订房成功！'
  },
  failText: {
    en:'Booking Failed! Please try again.',
    tc:'訂房失敗！請再試一次。',
    sc:'订房失败！请再试一次。'
  },
  bookingNumber: {
    en:'Booking Number: ',
    tc:'訂房編號：',
    sc:'订房编号：'
  },
  saveBookingText: {
    en:'Please save the booking number for inquiries purposes.',
    tc:'請保存訂房編號以便查詢',
    sc:'请保存订房编号以便查询' 
  },
  confirm:{
    en:'confirm',
    tc:'確認',
    sc:'确认'
  }
}
export default function PageNotFound() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const success = searchParams.get('success');
  const id = searchParams.get('id');
  const lang = searchParams.get('lang') || 'en';

  return (
    <div className='flex-1 flex w-full flex-col'>
      <div className='w-full flex flex-col items-center justify-center addnavpadding px-[12px] py-[48px] h-[80vh] border'>
        {success && <div className='text-d-24 font-bold text-[#816A34]'>{CONTENT.successText[lang]}</div>}
        {id && 
        <>
            <div className='text-d-24 font-bold text-[#816A34]'>{CONTENT.bookingNumber[lang]} <span className='text-black'>{id}</span></div>
            <div className='text-d-12 font-bold text-black mt-[24px]'>{CONTENT.saveBookingText[lang]}</div>
        </>
        }
        {!success && <div className='text-d-24 font-bold text-[#816A34]'>{CONTENT.failText[lang]}</div>}
        <div onClick={() => navigate('/')} className='btn-arrow mt-[48px] text-d-12 px-[88px] py-[12px] border border-[#0FBAB5] text-[#0FBAB5] relative select-none cursor-pointer hover:bg-[#0FBAB5] hover:text-white transition-all duration-300'>
            <div className='poltawski-nowy'>{CONTENT.confirm[lang]}</div>
        </div>
      </div>
      <Footer/>
    </div>
  );
}

